import { render, staticRenderFns } from "./NachCollectionActivity.vue?vue&type=template&id=48a960a6&scoped=true&"
import script from "./NachCollectionActivity.vue?vue&type=script&lang=js&"
export * from "./NachCollectionActivity.vue?vue&type=script&lang=js&"
import style0 from "../../assets/style/base.css?vue&type=style&index=0&id=48a960a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a960a6",
  null
  
)

export default component.exports